/**
 * Home progressive section reveal (SEO-safe).
 * Below-fold section HTML stays in the live DOM; CSS content-visibility /
 * containment skips paint until near the viewport. IntersectionObserver
 * promotes slots to --mounted (force visible + drop min-height reservation).
 * Theme Editor / designMode activate immediately.
 */
(function () {
  'use strict';

  // PSI PR2: slightly tighter than 320px so below-fold paint starts closer to viewport
  // (still preloads before scroll; hero/NL remain the LCP owners).
  var ROOT_MARGIN = '200px 0px';

  function activate(el) {
    if (!el || el.dataset.homeMounted === '1') return;

    el.dataset.homeMounted = '1';
    el.classList.add('home-progressive--mounted');

    // Drop the CLS reservation after the browser has laid out real content.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.minHeight = '';
      });
    });
  }

  function activateAll(nodes) {
    nodes.forEach(activate);
  }

  function init() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[data-home-progressive]')
    );
    if (!nodes.length) return;

    // Theme Editor: show everything immediately so merchants can edit.
    if (window.Shopify && window.Shopify.designMode) {
      activateAll(nodes);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      activateAll(nodes);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          activate(entry.target);
        });
      },
      { root: null, rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
